import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-quantity',
  templateUrl: './header-column-quantity.component.html',
  styleUrls: ['./header-column-quantity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnQuantityComponent extends HeaderColumnComponent {}
